import PropTypes from 'prop-types';
import {useEffect, useRef} from 'react';
import {useTheme, createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import loadArtemisFonts from '../../v2/components/ui/loadArtemisFonts';
import Translation from '../../v2/lang/Translation';
import {isMobile} from '../../v2/selectors/DeviceSelectors';
import isUsingArtemisStyles from '../../v2/selectors/isUsingArtemisStyles';

const useStyles = createUseStyles({
  sectionHeader: props => ({
    fontSize: props.theme.sectionHeader.fontSize,
    fontFamily: props.theme.sectionHeader.fontFamily,
    fontWeight: props.theme.sectionHeader.fontWeight || props.theme.core.boldFontWeight,
    fontStyle: props.theme.sectionHeader.isItalic && 'italic',
    fontStretch: props.theme.sectionHeader.fontStretch,
    lineHeight: props.theme.sectionHeader.lineHeight,
    letterSpacing: props.theme.sectionHeader.letterSpacing || props.theme.base.letterSpacing,
    textTransform: props.theme.sectionHeader.isUppercase && 'uppercase',
    color: props.isStepPending ? '#b3b3b3' : props.theme.base.color,
    display: 'flex',
    alignItems: 'center',
    
    ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.sectionHeader.font])
    && loadArtemisFonts(props.theme.typography[props.theme.sectionHeader.font], props.theme.sectionHeader.isBold),
  }),
});

export function SectionHeader(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const headerRef = useRef();
  
  useEffect(() => {
    if (props.isMobile && props.active) {
      headerRef.current.focus();
    }
  }, [props.isMobile, props.active]);
  
  const ariaLabel = props.step
    ? `${Translation.getText('step', [props.step])} ${Translation.getText(props.headerKey)}`
    : Translation.getText(props.headerKey);
  
  return (
    <div
      id={props.id}
      data-test="SectionHeader"
      ref={headerRef}
      tabIndex={-1}
    >
      <h2
        className={classes.sectionHeader}
        data-test="SectionHeader__header"
        aria-label={ariaLabel}
      >
        {props.step ? `${props.step}. ${Translation.getText(props.headerKey)}` : `${Translation.getText(props.headerKey)}`}
      </h2>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => ({
  active: state.ui.checkoutProgressStep === ownProps.step,
  isMobile: isMobile(state),
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

SectionHeader.propTypes = {
  id: PropTypes.string.isRequired,
  step: PropTypes.number,
  headerKey: PropTypes.string.isRequired,
  isStepPending: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
  
  // A11y
  active: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(SectionHeader);
